import { IEnvEngine, IEnvEngineConfig, IEnvServerProps } from '../interfaces';

import { EnvClient } from './environment-game-client';

// TODO: Populate as needed
export class EnvEngine extends EnvClient implements IEnvEngine {
  public server: IEnvServerProps;
  public internalB2BPassword: string;
  public matchMakingServer: string;

  public constructor() {
    super();
    this.server = { port: '', tag: '', host: '', maxMatches: 0, maxConnections: 0 };
    this.internalB2BPassword = '';
    this.matchMakingServer = '';
  }

  public init(config: IEnvEngineConfig) {
    super.init(config);

    const { SERVER_PORT, INTERNAL_B2B_TOKEN, MATCH_MAKING_SERVER, TAG, HOST, MAX_MATCHES, MAX_CONNECTIONS } = config;

    if (!SERVER_PORT) {
      throw new Error(`ENV VARIABLE "SERVER_PORT" not set`);
    }

    if (!INTERNAL_B2B_TOKEN) {
      throw new Error(`ENV VARIABLE "INTERNAL_B2B_TOKEN" not set`);
    }

    if (!MATCH_MAKING_SERVER) {
      throw new Error(`ENV VARIABLE "MATCH_MAKING_SERVER" not set`);
    }

    if (!TAG || !HOST || !MAX_MATCHES || !MAX_CONNECTIONS) {
      throw new Error(`ENV VARIABLE GES CONFIG: "TAG", "HOST", "MAX_MATCHES", "MAX_CONNECTIONS" not set`);
    }

    this.internalB2BPassword = INTERNAL_B2B_TOKEN;
    this.matchMakingServer = MATCH_MAKING_SERVER;
    this.server = {
      port: SERVER_PORT,
      tag: TAG,
      host: HOST,
      maxMatches: Number(MAX_MATCHES),
      maxConnections: Number(MAX_CONNECTIONS)
    };
  }

  public get props(): IEnvEngine {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    const { init, use, ...rest } = this;
    return rest;
  }

  public use(config: IEnvEngine) {
    Object.assign(this, config);
  }
}

export const envEngine = new EnvEngine();
